import React from 'react';
import ChallengeLanding from 'pages/challenge';

export default function () {
  return <ChallengeLanding entry="wlcCustomer" optinOverride />;
}
